
const addParametersToUrl = (paramName, paramVal = 'success') => {
    let thisPage = new URL(window.location.href);
    thisPage.searchParams.set(paramName, paramVal);
    history.pushState(null, null, thisPage);
}

export default addParametersToUrl;